export default "/react/logoSMMplanner-6605d30f.png";